import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import ManufacturingTopSection from "../components/manufacturing/ManufacturingTopSection";
import SwiperSection from "../components/SwiperSection/SwiperSection";
import ManufacturingFeature from "../components/ManufacturingFeature/ManufacturingFeature";
import Services from "../components/Services/Services";
import "./page.css";

const ManufacturingPage = () => {
  return (
    <div className="body learning-page">
      <Navbar />
      <ManufacturingTopSection
        title="AI Vision Platform For Robots & Manufacturing"
        description="Smart manufacturing integrates robotic welding with advanced sensors and automation to optimize efficiency, precision, and quality output."
        backgroundImage={require("../assets/images/manufacturing/manufacturing-bg-min4.jpg")}
        buttonText="Learn More"
        scrollTargetId="swiper-section"
      />
      <SwiperSection />
      <ManufacturingFeature />
      <Services />
      <Footer />
    </div>
  );
};

export default ManufacturingPage;
